import { navigationInit } from './modules/navigations';
import { faq } from './modules/faq';
import { shareOffer, shareOfferMobile } from './modules/shareOffer';
import { sliderScripts } from './../../block-acf/blocks/block-slider-and-text/script';
import { sliderScriptsImage } from './../../block-acf/blocks/block-slider-with-image-post/script';
import { logotypeIconsSilder } from './modules/logotypeIconsSilder';
import { showCode } from './modules/codeShow';
import { shareButton } from './modules/shareButton';

if (document.querySelector(".share-button")) { shareOffer(); }
if (document.querySelector(".share-button")) { shareOfferMobile(); }
if (document.querySelector(".collapsible")) { faq(); }
if (document.querySelector(".menuButton")) { navigationInit(); }
if (document.querySelector('.blockSliderAndText')) { sliderScripts(); }
if (document.querySelector('.blockSliderAndImage')) { sliderScriptsImage(); }
if (document.querySelector('.externalIconsArray')) { logotypeIconsSilder();}
if (document.querySelector('.singlePost__textWrapper.code')) { showCode();}
if (document.querySelector('.shareButton')) { shareButton();}

let navbar = document.querySelector(".header__content");
let navbarMain = document.querySelector(".header");
let sticky = navbar.offsetHeight;

document.addEventListener("touchmove", Scroll, false);
document.addEventListener("scroll", Scroll, false);

function Scroll() {
    if (window.scrollY >= sticky) {
        navbar.classList.add("sticky-header")
        navbarMain.classList.add("sticky-header-main")
    } else {
        navbar.classList.remove("sticky-header");
        navbarMain.classList.remove("sticky-header-main");
    }
}


